import { ValidationResult } from "../../validation/api"

export class SimpleFieldComponent {
    private readonly inputField: HTMLInputElement;
    private readonly emptyHint: HTMLElement;
    private readonly invalidHint: HTMLElement;
    private readonly companyHint: HTMLElement;
    private readonly parentOfHints: HTMLElement;
    private hasBeenFocusedOut = false

    private shouldShowError: boolean = false
    private error?: String

    constructor(documentObject: Document, inputField: string, private readonly validateImmediately: boolean) {
        this.inputField = documentObject.querySelector<HTMLInputElement>(`[data-qa="fti-registration-${inputField}-input"]`)!;
        this.emptyHint = documentObject.querySelector<HTMLElement>(`[data-qa="fti-registration-${inputField}-error-empty"]`)!;
        this.invalidHint = documentObject.querySelector<HTMLElement>(`[data-qa="fti-registration-${inputField}-error-invalid"]`)!;
        this.companyHint = documentObject.querySelector<HTMLElement>(`[data-qa="fti-registration-${inputField}-error-company"]`)!;
        this.parentOfHints = this.invalidHint.parentElement!;
    }

    get value(): string {
        return this.inputField.value
    }

    public registerEventListeners(inputListener: () => void) {
        const focusListener = () => {
            if (!this.hasBeenFocusedOut) {
                this.error = undefined
            }
            this.hasBeenFocusedOut = true
            this.setShouldShowError()
            this.registerEventListener("input", inputListener);
            return inputListener();
        };
        this.registerEventListener(this.validateImmediately ? "focusin" : "focusout", focusListener);
    }

    private setShouldShowError() {
        this.shouldShowError = true
        this.updateValidationState()
    }

    public setValidationResult(validationResult: ValidationResult) {
        this.error = validationResult.errorMessageId
        this.updateValidationState();
    }


    public clearErrors() {
        this.error = undefined;
        this.updateValidationState()
    }

    private updateValidationState() {
        if (this.error == undefined) {
            this.parentOfHints.classList.remove("pl_input--invalid");
            this.invalidHint.style.display = "none";
            this.emptyHint.style.display = "none";
            this.companyHint.style.display = "none";
        } else if (this.shouldShowError) {
            this.parentOfHints.classList.add("pl_input--invalid");
            if (this.error == "empty") {
                this.emptyHint.style.display = "unset";
                this.invalidHint.style.display = "none";
                this.companyHint.style.display = "none";
            } else if (this.error == "invalid") {
                this.invalidHint.style.display = "unset";
                this.emptyHint.style.display = "none";
                this.companyHint.style.display = "none";
            } else {
                this.companyHint.style.display = "unset";
                this.emptyHint.style.display = "none";
                this.invalidHint.style.display = "none";
            }
        }
    }

    private registerEventListener(eventType: string, listener: () => void) {
        this.inputField.removeEventListener(eventType, listener);
        this.inputField.addEventListener(eventType, listener);
    }
}
